import { EVENTS } from '../constants/tealiumData'
import { getContactInfo } from '../constants/tealiumDataConfig'

const getOnClickPayload = (event, payload) => {
  switch (event) {
    case EVENTS.ADD_ADDRESS:
    case EVENTS.ADD_EMAIL:
    case EVENTS.ADD_PHONE:
      return getContactInfo(payload)
    default:
      return null
  }
}

export default getOnClickPayload
